import React from 'react'

import NotFoundBlock from '../components/NotFoundBlock'

const NotFound = () => (
	<>
		<NotFoundBlock />
	</>
)
export default NotFound
